import config from '../config/config';

const encodePathSafely = (value) => {
  const normalized = String(value).replace(/\\/g, '/');
  const [pathAndQuery, hash = ''] = normalized.split('#');
  const [pathOnly, query = ''] = pathAndQuery.split('?');

  const encodedPath = pathOnly
    .split('/')
    .map((segment) => {
      if (!segment) {
        return segment;
      }

      try {
        return encodeURIComponent(decodeURIComponent(segment));
      } catch (_error) {
        return encodeURIComponent(segment);
      }
    })
    .join('/');

  return `${encodedPath}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
};

export const resolveMediaUrl = (rawUrl) => {
  if (!rawUrl) {
    return '';
  }

  const normalizedRawUrl = String(rawUrl).trim();

  if (/^(data:|blob:)/i.test(normalizedRawUrl)) {
    return normalizedRawUrl;
  }

  if (/^\/\//.test(normalizedRawUrl)) {
    return `https:${normalizedRawUrl}`;
  }

  // Accept domain-style URLs that are missing scheme, e.g. "www.site.com/image.jpg".
  if (/^(www\.|[a-z0-9-]+\.[a-z]{2,})(\/|$)/i.test(normalizedRawUrl)) {
    const withScheme = `https://${normalizedRawUrl}`;
    try {
      const parsed = new URL(withScheme);
      parsed.pathname = encodePathSafely(parsed.pathname);
      return parsed.toString();
    } catch (_error) {
      return encodeURI(withScheme);
    }
  }

  if (/^https?:\/\//i.test(normalizedRawUrl)) {
    try {
      const parsed = new URL(normalizedRawUrl);
      parsed.pathname = encodePathSafely(parsed.pathname);
      return parsed.toString();
    } catch (_error) {
      return encodeURI(normalizedRawUrl);
    }
  }

  const normalizedPath = normalizedRawUrl.startsWith('/')
    ? normalizedRawUrl
    : `/${normalizedRawUrl}`;
  const encodedPath = encodePathSafely(normalizedPath);
  const trimmedBase = String(config.serverBaseUrl || '').replace(/\/+$/, '');

  return `${trimmedBase}${encodedPath}`;
};

export default resolveMediaUrl;